<template>
  <div class="estimate-detail">
    <LableContent
      label="总预算明细"
      class="gusuan-detail"
      hasCollapse
      showFullScreen
      height="450px"
      bottomPadding="0px"
    >
      <TabBtn
        ref="tabBtnRef"
        :tabs="tabs"
        :active-tab="tabActive"
        height="100%"
        @tab-click="initData"
      >
        <template slot="btn">
          <el-button type="primary" size="mini" @click="handleGlobalEstimate">
            全局预算
          </el-button>
        </template>
        <template>
          <SimpleTable
            ref="topTable"
            :menus="menus"
            height="50%"
            :columns="columns.top"
            :data="tableData.top"
            table-code="EstimateDetailTop"
            :loading="loading.top"
            @row-select="onRowSelectTop"
            @modify-data-change="onModifyDataChangeTop"
          />
        </template>
      </TabBtn>
    </LableContent>

    <LableContent
      label="动态估算"
      class="gusuan-detail"
      hasCollapse
      showFullScreen
      height="350px"
      topPadding="0px"
    >
      <div class="left-right-box1" style="height: 100%">
        <SimpleTable
          width="70%"
          ref="leftTable"
          :columns="columns.left"
          :data="tableData.left"
          table-code="EstimateDetailLeft"
          :loading="loading.left"
        />
        <SimpleTable
          width="calc(30% - 11px)"
          ref="rightTable"
          :menus="['查询', '上传', '批量删除']"
          :columns="columns.right"
          :data="tableData.right"
          table-code="EstimateDetailRight"
          :loading="loading.right"
          :uploadParams="uploadParams"
          @cell-dblclick="handleCellDblclickRight"
        />
      </div>
    </LableContent>

    <SelectBaseAmountDialog
      ref="SelectBaseAmountDialog"
      @confirm="handleSelectBaseAmountDialogConfirm"
    />
  </div>
</template>

<script>
import SimpleTable from '@/components/SimpleTable/index.vue'
import TabBtn from '@/components/TabBtn/index.vue'
import SelectBaseAmountDialog from '../../DesignBudgetSoftware/InitialSchemeEstimate/SelectBaseAmountDialog.vue'
import { tabs, tabsHistory } from './config'
import { sortRecords, addCbFn, preViewFile } from '@/utils/index'
import LableContent from '@/components/LableContent/index.vue'
export default {
  name: 'EstimateDetail',
  components: {
    SimpleTable,
    TabBtn,
    SelectBaseAmountDialog,
    LableContent
  },
  inject: ['detailsVm'],
  props: {
    basicInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tabs,
      tabActive: tabs[0].value,
      currentTab: null,

      columns: {
        top: [],
        left: [],
        right: []
      },
      tableData: {
        top: [],
        left: [],
        right: []
      },
      tabsHistory,
      tabHistoryActive: tabsHistory[0].value,
      currentTabHistory: tabsHistory[0],

      loading: {
        top: false,
        left: false,
        right: false
      },
      currentSelect: {
        top: null,
        left: null,
        right: null
      },
      uploadParams: {
        id: '',
        accept: '',
        uploadAfter: () => this.uploadAfter()
      }
    }
  },
  computed: {
    menus() {
      if (
        ['pofeOpsIncome', 'pofeInvestmentEstimate'].includes(
          this.currentTab.value
        )
      ) {
        return ['查询']
      } else if (this.currentTab.value === 'pofeProjectUnitCost') {
        return ['查询', '插入', '批量修改', '批量删除']
      }
      return ['查询', '插入', '批量修改', '批量删除', '选中模板', '保存模板']
    }
  },
  created() {
    this.init()
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法
    init() {
      if (this.$refs.tabBtnRef) this.$refs.tabBtnRef.active = tabs[0].value
      for (const element of tabs) {
        const arr = [
          'tcbeLandCost',
          'tcbeChargingItems',
          'tcbeSaleCost',
          'tcbeFinanceCost',
          'tcbeOpsCost',
          'tcbeOpsIncome',
          'tcbeSaleIncome'
        ]
        if (arr.includes(element.value)) {
          const obj = element.columns.top.find(e => e.field === 'baseAmount')
          obj.handleEdit = this.handleEditBillBaseAmount
        }
      }

      this.initData(this.tabs.find(item => item.value === this.tabActive))
    },

    initData(currentTab) {
      this.currentTab = currentTab

      this.columns.top = currentTab.columns.top
      this.columns.left = currentTab.columns.left
      this.columns.right = currentTab.columns.right

      this.getTable('top', currentTab.url)
    },
    async getTable(type, url) {
      this.tableData[type] = []
      this.tableData.left = []
      this.tableData.right = []
      this.loading[type] = true
      const res = await this.$service.get(`${url}/list`, {
        mainId: this.basicInfo.id
      })
      this.loading[type] = false
      this.tableData[type] = sortRecords(res?.data || [])
      if (res.data?.length) this.$refs[type + 'Table'].initialized()
    },

    // 查时间分布
    async getLeftTable(type = 'left') {
      this.tableData[type] = []
      if (!this.currentSelect.top?.id) return
      this.loading[type] = true
      const res = await this.$service.get(`/common-time-distribution/list`, {
        tcbeId: this.basicInfo.id,
        itemId: this.currentSelect.top?.id
      })
      this.loading[type] = false
      this.tableData[type] = sortRecords(res?.data || [])
    },
    async getRightTable(type = 'right') {
      this.tableData[type] = []
      if (!this.currentSelect.top?.id) return
      this.loading[type] = true
      const res = await this.$service.get(
        `/business-file/list/${this.currentSelect.top?.id}`,
        {
          projectUnitId: this.currentSelect.top?.id,
          designOptionsId: this.basicInfo.pofeId
        }
      )
      this.loading[type] = false
      this.tableData[type] = sortRecords(res?.data || [])
    },

    onRowSelectTop(rows) {
      const selectedRecord = rows[0]
      const obj = selectedRecord[0].originData
      if (this.currentSelect.top?.id === obj?.id) return
      this.currentSelect.top = obj
      this.uploadParams.id = obj?.id

      this.getLeftTable()
      this.getRightTable()
    },

    async onModifyDataChangeTop(getModifyData, cleanModifyData) {
      await addCbFn(
        this.$service,
        `${this.currentTab.url}/batch`,
        getModifyData,
        cleanModifyData,
        arr => arr.map(e => ({ ...e, mainId: this.basicInfo.id }))
      )
    },

    async uploadAfter() {
      this.getRightTable()
    },

    // 全局估算
    async handleGlobalEstimate() {
      this.detailsVm.loadingContainer = true
      const res = await this.$service.post(
        `/construction-budget-estimate/global-estimate/${this.basicInfo.id}`
      )
      this.detailsVm.loadingContainer = false
      if (res?.code === 200) {
        this.$message.success('操作成功')
        this.init()
        this.detailsVm.getBaseInfo(this.basicInfo.id)
      }
    },

    // 取费基数编辑
    handleEditBillBaseAmount(selectedCellInfos) {
      if (selectedCellInfos.length !== 1)
        return this.$message.warning('只能修改一条数据！')
      this.$refs.SelectBaseAmountDialog.show({
        id: this.basicInfo.id,
        selectedCellInfos: selectedCellInfos
      })
    },

    // 取费基数编辑确认
    handleSelectBaseAmountDialogConfirm(selectedCellInfos, str) {
      selectedCellInfos.forEach(cells => {
        const obj = cells[0].originData
        this.$set(obj, 'baseAmount', str)
        this.$refs.topTable.modifyData.set(obj, obj)
      })
    },

    handleCellDblclickRight(args) {
      preViewFile(args.originData?.path)
    }
  }
}
</script>

<style scoped lang="less">
.estimate-detail {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 10px;
  ::v-deep .tab-btn .table {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    > div {
      flex: 1;
      height: 33% !important;
    }
  }

  .top-table {
    height: 300px;
  }

  .bottom-table {
    height: 300px;
  }

  .left-right-box1 {
    margin-top: 10px;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 10px;
  }

  .project-overview-box {
    height: 100% !important;
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 12px;
    > div {
      flex: 1;
    }
  }
}
</style>
